<div ng-controller="competencyDetailsController as compDetCtrl">
    <c-competency competency="compDetCtrl.competency"></c-competency>
</div>